import Image from "next/image";
import { useRouter, usePathname, useParams } from "next/navigation";
import React, { useEffect, useRef, useState } from "react";

export default function Language() {
  const router = useRouter();
  const pathname = usePathname();
  const params = useParams();
  const currentLocale = (params?.locale as string) || "vi";

  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
  const languageRef = useRef<HTMLDivElement>(null);
  const [selectedLanguage, setSelectedLanguage] = useState(currentLocale);

  const handleLanguageItemClick = (selectedLocale: string) => {
    setIsLanguageMenuOpen(false);
    if (selectedLocale !== currentLocale) {
      setSelectedLanguage(selectedLocale);
      document.cookie = `NEXT_LOCALE=${selectedLocale}; path=/; max-age=31536000; SameSite=Lax`;
      // Replace the locale segment in the current path
      const segments = pathname.split("/");
      segments[1] = selectedLocale; // replace /vi or /en with new locale
      router.push(segments.join("/"));
    }
  };

  const handleLanguageMenuToggle = () => {
    setIsLanguageMenuOpen(!isLanguageMenuOpen);
  };

  useEffect(() => {
    setSelectedLanguage(currentLocale);
  }, [currentLocale]);

  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      if (
        isLanguageMenuOpen &&
        languageRef.current &&
        e.target instanceof Node &&
        !languageRef.current.contains(e.target)
      ) {
        setIsLanguageMenuOpen(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [isLanguageMenuOpen]);

  return (
    <div style={{ position: "relative" }} ref={languageRef}>
      <div
        style={{
          cursor: "pointer",
          width: 18,
          height: 18,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
        onClick={handleLanguageMenuToggle}
      >
        <Image
          src={
            selectedLanguage === "vi"
              ? "/icons/icon_VnFlag.svg"
              : "/icons/icon_EnFlag.svg"
          }
          alt={selectedLanguage === "vi" ? "Ngôn ngữ Việt" : "English"}
          width={18}
          height={18}
          style={{ objectFit: "cover", borderRadius: "2px" }}
        />
      </div>

      {isLanguageMenuOpen && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            right: 0,
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#fff",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
            borderRadius: "5px",
            padding: "5px",
            zIndex: 1,
            minWidth: "120px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              padding: "6px 8px",
            }}
            onClick={() => handleLanguageItemClick("vi")}
          >
            <div
              style={{
                width: "20px",
                height: "20px",
                marginRight: "8px",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Image
                src="/icons/icon_VnFlag.svg"
                alt="Ngôn ngữ Việt"
                width={20}
                height={20}
                style={{ objectFit: "cover", borderRadius: "2px" }}
              />
            </div>
            <div style={{ fontSize: "14px", fontWeight: 450, color: "#333" }}>Vietnamese</div>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              padding: "6px 8px",
            }}
            onClick={() => handleLanguageItemClick("en")}
          >
            <div
              style={{
                width: "20px",
                height: "20px",
                marginRight: "8px",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Image
                src="/icons/icon_EnFlag.svg"
                alt="English"
                width={20}
                height={20}
                style={{ objectFit: "cover", borderRadius: "2px" }}
              />
            </div>
            <div style={{ fontSize: "14px", fontWeight: 450, color: "#333" }}>English</div>
          </div>
        </div>
      )}
    </div>
  );
}
